import React from 'react';
import classnames from 'classnames';
import s from './GroupLinkLoader.scss';
var GroupLinkLoader = function (_a) {
    var className = _a.className, isCollapsed = _a.isCollapsed;
    return (React.createElement("div", { className: classnames(s['root'], isCollapsed && s['collapsed'], className) },
        React.createElement("div", { className: s['avatar'] }),
        !isCollapsed && React.createElement("div", { className: s['username'] })));
};
GroupLinkLoader.displayName = 'GroupLinkLoader';
export default GroupLinkLoader;
//# sourceMappingURL=GroupLinkLoader.js.map